import { httpservice } from '../services';
import { constants } from '../constant/constant';
import { SHARED_AUTH_URLS } from '../constant/actionTypes';

const apiEndPoint = constants.CLIENT_URL;

const getSharedAuthUrls = () => (dispatch) => httpservice()
  .get(`${apiEndPoint}${constants.API.SHARED_AUTH_URLS}`)
  .then((result) => {
    dispatch({
      payload: result.data.response.data,
      type: SHARED_AUTH_URLS.GET.SUCCESS,
    });
  })
  .catch((error) => {
    dispatch({
      payload: error,
      type: SHARED_AUTH_URLS.GET.ERROR,
    });
  });

export default getSharedAuthUrls;
